import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { QuestionBankModel } from '../../models/question-bank.model';
import { DocumentModel } from '../../models/document.model';
import { CompanyAuditService } from '../../services/company-audit.service';
import { CompanyAuditModuleViewModel } from '../../models/company-audit-module-view.model';
import { CompanyUserModel } from 'app/shared/models/company-user.model';
import { ICompanyAuditDetailsModel } from 'app/company-audit/models/company-audit-details.model';

@Component({
  selector: 'app-company-audit-module',
  templateUrl: './company-audit-module.component.html',
  styleUrls: ['./company-audit-module.component.css']
})
export class CompanyAuditModuleComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    createAuditFrom: FormGroup;
    auditModule: CompanyAuditModuleViewModel;
    submitAttempt: boolean = false;
    auditId: string;
    moduleId: string;
    questionsModel: QuestionBankModel[];
    auditDocuments: DocumentModel[];
    companyUser: CompanyUserModel;
    companyAuditModel: ICompanyAuditDetailsModel;

    constructor(
        private companyAuditService: CompanyAuditService,
        private activatedRoute: ActivatedRoute
    ) {
    }

    ngOnInit() {

        this.auditId = this.activatedRoute.snapshot.params['auditId'];
        this.moduleId = this.activatedRoute.snapshot.params['moduleId'];

        this.companyAuditService.get(this.auditId).subscribe(auditInfo => {
            this.companyAuditModel = auditInfo;
            this.companyAuditService.getAuditModule(this.auditId, this.moduleId).subscribe(auditModule => {
                this.auditModule = auditModule;
                this.headerTitle = {
                    title: auditModule.moduleDescription,
                    breadcrumbs: [
                        { title: 'Company Audits', url: ['/company-audit'] },
                        { title: auditInfo.title, url: ['/company-audit/' + this.auditId] }
                    ]
                };
            });
        });


        this.companyAuditService.getQuestions(this.auditId, this.moduleId).subscribe(
            questions => {
                this.questionsModel = questions;
            },
            error => this.errors = error.errorList
        );

        // ---------- Load uploaded documents for this module ---------- //
        this.getDocuments();


    }

    getDocuments() {
        this.companyAuditService.getDocuments(this.moduleId).subscribe(
            documents => {
                this.auditDocuments = documents;
            },
            error => this.errors = error.errorList
        );
    }

    onDocumentUploaded($event): void {
        this.getDocuments();
    }

    deleteDocument(documentId): void {
        this.companyAuditService.deleteDocument(documentId).subscribe(
            result => {
                this.getDocuments();
            },
            error => {
                console.log(error);
            }
        );
    }

}
